import {
  Box,
  Container,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import Header from "../../components/header";
import AppFooter from "../../components/footer";
import { appIcons, appImages } from "../../assets";
import EducationCityDetailCard from "../../components/cards/EducationDetailCard";
import BoxContainer from "./../../components/container/boxContainer";
import ReviewBox from "../../components/reviewBox";
import ReviewData from "../../json/Reviews.json";
import GlobalButton from "../../components/button";
import { useLocation, useNavigate } from "react-router-dom";

const EducationalCityDetails = () => {
  const { palette } = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleNavigateToForm = () => {
    let result = state.name.toLowerCase().replace(/\s+/g, "-");
    navigate(`/education-city/${result}/form`);
  };

  return (
    <>
      <Box
        height={{ xs: "60vh", sm: "100vh" }}
        display="flex"
        flexDirection="column"
        position={"relative"}
        sx={{
          background: palette.gradient.background,
          backgroundImage: `url(${appImages.educationCityDetailBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />

        {/* wave image */}
        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,
            zIndex: 1,
          }}
        />
      </Box>

      <Box position={"absolute"} top={{ xs: 130, sm: 150 }} left={0} right={0}>
        <Container
          sx={{
            maxWidth: "1100px !important",
            position: "relative",
            zIndex: 999,
            // flexGrow: 1, // Allows content to grow and push footer down
          }}
        >
          <GlobalButton
            handleClickBtn={() => navigate(-1)}
            variant={"outlined"}
            btnText={"Back"}
            startIcon={<img src={appIcons.whiteArrowBackIcon} width={30} />}
            styleProps={{
              color: "text.white",
            }}
          />

          <Typography
            variant="heading_pr"
            component={"h1"}
            maxWidth={700}
            margin={"auto"}
            textAlign={"center"}
            color={"text.white"}
            lineHeight={"normal"}
            mb={5}
          >
            Select the best school service for your child's learning and
            development.
          </Typography>

          <EducationCityDetailCard handleApply={handleNavigateToForm} />

          <BoxContainer sx={{ my: 2 }}>
            <Typography>All Reviews</Typography>
          </BoxContainer>

          <ReviewBox data={ReviewData} />
        </Container>
        <AppFooter />
      </Box>
    </>
  );
};

export default EducationalCityDetails;
